// @ts-nocheck
import StorageService from "../services/StorageService";
import Registry from "../utils/Registry";
const formWrapperSelector = ".js-customer-survey";
const formSelector = ".js-customer-survey-form";
// See names for all fields in `themes/base/partials/_customer_survey.liquid`
const rating1Name = "entry.183976575";
const rating2Name = "entry.294436083";
const msgName = "entry.1340586078";
const subjectName = "entry.2144080433";
function onSubmit(orderId) {
    $(formSelector).on("submit", function () {
        $("#customer-survey-rating").addClass("hidden");
        $("#customer-survey-thanks").removeClass("hidden");
        StorageService.setItem("customerSurvey", orderId);
    });
}
function setHiddenValues(order) {
    $(".js-order-method-input").attr("value", order.origin == "Bar" && order.onlinePayment ? "qrwaiter" : "");
    $(".js-order-id-input").attr("value", order.id);
}
function toggleVisibilityFields(visibilityCondition, sectionSelector, targetFieldSelector, onChangeSelector = formSelector) {
    $(onChangeSelector).on("change", (e) => {
        if (visibilityCondition()) {
            $(sectionSelector).removeClass("hidden");
            $(targetFieldSelector).attr("required", true);
        }
        else {
            $(sectionSelector).addClass("hidden");
            $(targetFieldSelector).attr("required", false);
        }
    });
}
function getValue(el) {
    if ($(el).attr("type") === "radio") {
        return $(`[name='${$(el).attr("name")}']:checked`).val();
    }
    else {
        return $(el).val();
    }
}
function setupConditionalFields() {
    // Show subject field only when ratings are done.
    const subjectCondition = () => parseInt($(`[name='${rating1Name}']:checked`).val()) <= 2 ||
        parseInt($(`[name='${rating2Name}']:checked`).val()) <= 2;
    // Show textarea field only when all required fields are done.
    const messageCondition = () => {
        let requiredDone = true;
        $(formSelector)
            .find("input, select")
            .filter("[required]")
            .each((i, el) => {
            if (!getValue(el)) {
                requiredDone = false;
            }
        });
        return requiredDone;
    };
    toggleVisibilityFields(subjectCondition, "#customer-survey-subject-section", `[name='${subjectName}']`, ".js-customer-survey-rating");
    toggleVisibilityFields(messageCondition, "#customer-survey-message-section", `[name='${msgName}']`);
}
export default {
    init: function () {
        // orderId published by orderInfoWidget
        Registry.get("order").then((order) => {
            if (StorageService.getItem("customerSurvey") === String(order.id)) {
                return;
            }
            setupConditionalFields();
            setHiddenValues(order);
            $(formWrapperSelector).removeClass("hidden");
            onSubmit(order.id);
        });
    },
};
